module.exports = __webpack_public_path__ + "img/service-video.76b16cce.svg";